<script setup lang="ts">
import type { City } from '~/interfaces/city'
import useCityStore from '~/store/city'

const cityStore = useCityStore()

const props = defineProps({
    closeCity: {
        type: Object as PropType<City>,
        default: () => ({})
    }
})

const closeCityName = computed(() => props.closeCity?.name || cityStore.name)
const closeCitySlug = computed(() => props.closeCity?.slug || cityStore.slug)

const closeCityCountryCode = computed(
    () => props.closeCity?.countryCode || cityStore.countryCode
)
</script>

<template>
    <a
        :href="`/cities/${closeCitySlug}-${closeCityCountryCode}`"
        :title="closeCityName"
    >
        {{ closeCityName }}
    </a>
</template>

<style scoped lang="scss">
a {
    @apply text-sky-500 hover:text-sky-400;
}
</style>
